import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { Invito } from './features/sessione/Invito';
import './styles/index.css';

const radice = document.getElementById('radice');
if (!radice) throw new Error("Manca l'elemento #radice in index.html.");

/*  UNA SOLA SCHERMATA STA FUORI DALL'APPLICATIVO, e si riconosce dal percorso.

    TeraWorks non ha rotte: la schermata si sceglie con l'ancora, dentro un guscio che
    presuppone una sessione. L'invito no — ci arriva chi non e' entrato, ed e' il motivo
    per cui ci arriva — quindi si decide qui, prima di costruire l'applicativo: cosi' non
    esiste nessuno stato in cui il guscio chiede al server chi sei mentre la persona sta
    leggendo «scegli la password».

    E' l'unico percorso vero dell'applicativo, e per questo `index.html` deve rispondere
    anche su `/invito`: ci pensa MapFallbackToFile dal lato del server, e il server di
    sviluppo lo fa da se'.
*/
const biglietto =
  window.location.pathname === '/invito'
    ? (new URLSearchParams(window.location.search).get('t') ?? '')
    : null;

createRoot(radice).render(
  <StrictMode>
    {biglietto === null ? (
      <App />
    ) : (
      <div className="guscio">
        <main>
          <Invito biglietto={biglietto} />
        </main>
      </div>
    )}
  </StrictMode>,
);

// Aggiornamento su richiesta invece che a sorpresa: ricaricare l'app mentre
// un operaio sta compilando un rapportino sarebbe il modo peggiore di aggiornarla.
const aggiorna = registerSW({
  onNeedRefresh() {
    if (window.confirm("È disponibile una versione aggiornata. Ricaricare adesso?")) {
      void aggiorna(true);
    }
  },
});
